import instance from "@/services/instance.js";

/**
 * WEBINAR SERVICES
 */
const CreateWebinar = (payload) => {
  return instance.instanceToken.post("content/webinar", payload);
};

const EditWebinar = (id, payload) => {
  return instance.instanceToken.put(`/content/webinar/${id}`, payload);
};

const GetWebinarById = (id) => {
  return instance.instanceToken.get(`/content/webinar/${id}`);
};

const GetWebinars = (params) => {
  return instance.instanceToken.get("/content/webinars", { params });
}

const DeleteWebinar = (id) => {
  return instance.instanceToken.delete(`/content/webinar/${id}`);
};

/** 
 * TRAINING SERVICES
 */
const CreateTraining = (payload) => {
  return instance.instanceToken.post("content/training", payload);
};

const EditTraining = (id, payload) => {
  return instance.instanceToken.put(`/content/training/${id}`, payload);
};

const GetTrainingById = (id) => {
  return instance.instanceToken.get(`/content/training/${id}`);
};

const GetTrainings= (params) => {
  return instance.instanceToken.get("/content/trainings", { params });
}

const DeleteTraining = (id) => {
  return instance.instanceToken.delete(`/content/training/${id}`);
};


export default {
  createWebinar: CreateWebinar,
  editWebinar: EditWebinar,
  getWebinar: GetWebinarById,
  getWebinars: GetWebinars,
  deleteWebinar: DeleteWebinar,

  createTraining: CreateTraining,
  editTraining: EditTraining,
  getTraining: GetTrainingById,
  getTrainings: GetTrainings,
  deleteTraining: DeleteTraining,
};
